import { ActionType } from '../../constants/ActionTypes'

export default function playersReducer(state = {}, action) {
    switch (action.type) {
        // Get Users
        case ActionType.GET_PLAYERS_BEGIN:
            return {
                ...state,
                inProcess: true
            }
        case ActionType.GET_PLAYERS_SUCCESS:
            return {
                ...state,
                inProcess: false,
                players: action.payload.Data
            }

        case ActionType.GET_PLAYERS_FAILURE:
            return {
                ...state,
                inProcess: true
            }

        // Top Up Players
        case ActionType.TOPUP_PLAYER_BEGIN:
            return {
                ...state,
                inProcess: true
            }
        case ActionType.TOPUP_PLAYER_SUCCESS:
            return {
                ...state,
                inProcess: false,
                topup: action.payload.Data
            }

        case ActionType.TOPUP_PLAYER_FAILURE:
            return {
                ...state,
                inProcess: true
            }
        case ActionType.GET_PLAYER_BALANCE_BEGIN:
            return {
                ...state,
                inProcess: true
            }
        case ActionType.GET_PLAYER_BALANCE_SUCCESS:
            return {
                ...state,
                inProcess: false,
                playerBalance: action.payload.Data
            }

        case ActionType.GET_PLAYER_BALANCE_FAILURE:
            return {
                ...state,
                inProcess: true
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/subAffiliate/PlayersReducer.js